import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const Blog: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title={t('support:blog.seoTitle')}
        description={t('support:blog.seoDescription')}
        url="/diger/blog"
      />
      <div className="min-h-screen bg-dark-900 pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <div className="w-20 h-20 mx-auto mb-6 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center">
              <BookOpen className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t('support:blog.title')}
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              {t('support:blog.description')}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-dark-800/50 backdrop-blur-sm rounded-2xl p-8 border border-dark-700 text-center"
          >
            <FileText className="w-16 h-16 text-primary-400 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-white mb-4">{t('support:blog.comingSoon')}</h2>
            <p className="text-gray-400">
              {t('support:blog.stayTuned')}
            </p>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default Blog;
